import React from 'react';
import { Calendar, Clock, Building2, Video, Plus, Search, Filter, ChevronDown, List, CalendarDays, Eye, Edit, Trash2, AlertCircle, CheckCircle, Loader, X, ChevronLeft, ChevronRight, Users, TrendingUp, FileText, Briefcase, Target, MessageSquare, Brain, Zap } from 'lucide-react';
import Button from '@/components/ui/Button';

const ListView = ({ 
isLoading,
interviews,
setShowScheduleModal,
getStatusConfig,
handleViewDetails
}) => {


return (

// List View
<div className="space-y-4">
{isLoading ? (
<div className="bg-white rounded-lg shadow-sm p-12 text-center border border-gray-200">
<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
<p className="text-gray-600">Loading interviews...</p>
</div>
) : interviews.length === 0 ? (
<div className="bg-white rounded-lg shadow-sm p-12 text-center border border-gray-200">
<Calendar className="w-16 h-16 text-gray-300 mx-auto mb-4" />
<h3 className="text-lg font-semibold text-gray-900 mb-2">No interviews scheduled</h3>
<p className="text-gray-600 mb-4">Schedule your first interview to get started</p>
<button
onClick={() => setShowScheduleModal(true)}
className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
>
Schedule Interview 
</button>
</div>
) : (
interviews.map((interview) => {
const statusConfig = getStatusConfig(interview.status);
return (
<div key={interview.id} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
<div className="flex flex-col md:flex-row gap-6">
<div className="flex-shrink-0">
<img
src={interview.companyLogo}
alt={interview.company}
className="w-16 h-16 rounded-lg object-cover"
/>
</div>

<div className="flex-1 min-w-0">
<div className="flex items-start justify-between mb-3">
<div>
<div className="flex items-center gap-2 mb-1">
<h3 className="text-xl font-semibold text-gray-900">{interview.jobTitle}</h3>
{['mock_preparation', 'mock_practice'].includes(interview?.type) && (
<span className="px-2 py-1 bg-purple-100 text-purple-700 text-xs font-medium rounded">
AI Mock
</span>
)}
</div>
<div className="flex items-center gap-4 text-sm text-gray-600">
<span className="flex items-center gap-1">
<Building2 className="w-4 h-4" />
{interview.company}
</span>
<span className="flex items-center gap-1">
<Calendar className="w-4 h-4" />
{new Date(interview.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
</span>
<span className="flex items-center gap-1">
<Clock className="w-4 h-4" />
{interview.time}
</span>
</div>
</div>

{/* Status */}
<div className={`px-3 py-1 rounded-full text-sm capitalize font-medium ${statusConfig.color}`}>
{statusConfig.label}
</div>

</div>

<div className="flex flex-wrap items-center gap-4 mb-4 text-sm">
<div>
<span className="text-gray-600">Interview Round: </span>
<span className="font-medium text-gray-900">{interview.interviewType}</span>
</div>
<div>
<span className="text-gray-600">Location: </span>
<span className="font-medium text-gray-900">{interview.location}</span>
</div>
</div>


<div className="mb-4 p-3 bg-purple-50 border border-purple-200 rounded-lg">
<p className="text-xs text-purple-600 mt-1">
Reminders are sent 1 hour and 30 minutes before
</p>
</div>


<div className="flex justify-end items-center gap-3">


<Button
variant="link"
size="sm"
iconName="Eye"
iconPosition="left"
iconSize={16}
onClick={() => handleViewDetails(interview)}
>
View Details
</Button>

</div>


</div>
</div>
</div>
);
})
)}
</div>

);
};

export default ListView;